import type { TProfissao } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class GetProfissoesService extends HttpService {
  async execute() {
    return this.http.get<TProfissao[]>('api/v2/Profissao/lista')
  }
}
